export const GET_DETAIL_SHIPMENT = 'GET_DETAIL_SHIPMENT'
export const GET_DETAIL_SHIPMENT_SUCCESS = 'GET_DETAIL_SHIPMENT_SUCCESS'
export const GET_DETAIL_SHIPMENT_FAILS = 'GET_DETAIL_SHIPMENT_FAILS'
export const CHANGE_SHIPMENT_DETAIL = 'CHANGE_SHIPMENT_DETAIL'
export const RESET_STATE_SHIPMENT_DETAIL = 'RESET_STATE_SHIPMENT_DETAIL'

export function getDetailShipmentSuccess(payload) {
    return {
        type: GET_DETAIL_SHIPMENT_SUCCESS,
        payload,
    }
}

export function getDetailShipment(payload) {
    return {
        type: GET_DETAIL_SHIPMENT,
        payload,
    }
}

export function getDetailShipmentFails(payload) {
    return {
        type: GET_DETAIL_SHIPMENT_FAILS,
        payload,
    }
}

export function changeShipmentDetail(payload) {
    return {
        type: CHANGE_SHIPMENT_DETAIL,
        payload,
    }
}

export function resetStateShipmentDetail(payload) {
    return {
        type: RESET_STATE_SHIPMENT_DETAIL,
        payload,
    }
}


// WEBPACK FOOTER //
// ./src/actions/detailShipment.js